/* eslint-disable no-dupe-keys */
export default {
  third_party_service_trace: {
    name: '第三方服务访问日志',
    // 属性（一般与对象内容匹配）
    prop: {
      service_name: '服务',
      associated: '关联的对象',
      from_service: '访问来源',
      action: '动作',
      api_uri: 'API地址',
      request_params: '请求参数',
      response_data: '请求响应',
      http_status: 'HTTP状态码',
      description: '描述',
      business_status: '业务状态',
      require_callback: '需要回调',
      callback_ref: '回调参照',
      created_at: '访问时间',
      updated_at: '更新时间',
      remote_address: 'IP',
      operator: '操作人'
    },
    // Enum的属性
    from_services: {
      our_service: '我方服务',
      third_party_service: '第三方服务'
    },
    business_statuses: {
      do_success: '成功',
      do_fail: '失败',
      waiting_callback: '等待回调'
    },
    service_names: {
      nvr: '摄像头',
      parking_lock: '地锁',
      wechat: '微信',
      alipay: '支付宝',
      parking_relief: '停车减免',
      nmc: '气象查询',
      meituan: '美团',
      wechat_official: '微信'
    },
    service_icons: {
      nvr: 'el-icon-video-camera',
      parking_lock: 'iconfont lc-icon-parking_lock_up',
      wechat: 'iconfont lc-icon-wechat',
      alipay: 'iconfont lc-icon-alipay',
      parking_relief: 'iconfont lc-ico-car'
    },
    actions: {
      // nvr
      screenshot: '截屏',
      play_video: '播放视频',
      parking_lock_control: '地锁控制',
      parking_lock_bluetooth: '读地锁蓝牙码',
      orderquery: '订单查询',
      refund: '微信退款',
      unifiedorde: '微信下单',
      alipay_trade_refund: '支付宝退款',
      alipay_trade_query: '支付宝订单查询',
      transfer: '微信转账',
      parking_fee_relief: '停车费减免',
      put_discount: '优惠下发',
      internal_sign: '密钥获取',
      streaming: '播放',
      weathe: '气象查询',
      receipt: '输码验券校验',
      oauth: '商家授权',
      wechat_official_ocr_driving: '微信行驶证 OCR 识别'
    },
    action_icons: {
      // nvr
      screenshot: 'el-icon-picture-outline',
      play_video: 'el-icon-video-play',
      parking_lock_control: 'el-icon-set-up',
      parking_lock_bluetooth: 'iconfont lc-icon-bluetooth-circle',
      orderquery: 'el-icon-search',
      parking_fee_relief: 'iconfont lc-ico-car'
    },
    // Boolean的属性
    require_callbacks: { true: '是', false: '否' },
    // 占位提示
    placeholder: {
      search_keyword: '关联对象ID/API/参数/响应'
    },
    // 详情页标签
    labels: {
      our_access_count: '我方访问数',
      third_party_access_count: '第三方访问数',
      latest_days_fail_count: '近7天失败的请求数',
      latest_days_waiting_count: '近7天回调的等待数'
    }
  }
}
